import { Button, ButtonWithPopOut } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { capitalize } from "@s-libs/micro-dash";

import {
  buttonContainerCss,
  buttonWithPopoutCss,
  getSortByButtonOptionCss,
  popoutContainerCss,
  selectedOptionIndicatorCss,
} from "@/search/NewSearchPageMVP/ContentTypeFilter/ContentHeaderSortByButton/ContentHeaderSortByButton.styles";
import {
  SORT_BY_FILTER_OPTIONS,
  SORT_BY_RELEVANCE_FILTER_OPTION,
} from "@/search/NewSearchPageMVP/NewSearchPageMVP.constants";
import { useSearchPageContext } from "@/search/NewSearchPageMVP/provider/SearchPageProvider";
import { AgathaSchemaParamsEnum } from "@/search/NewSearchPageMVP/types/IParametersSchema";

const ButtonWithTrackEvent = withTrackEvent(Button);

const ContentHeaderSortByButton = () => {
  const {
    handlers: {
      getSearchParamValues,
      setSearchParamValue,
      hasSearchParamValue,
    },
  } = useSearchPageContext();

  const selectedSortByValue = getSearchParamValues(
    AgathaSchemaParamsEnum.sort_by,
  )?.[0];
  const selectedSortByLabel =
    SORT_BY_FILTER_OPTIONS.find(
      (option) => option.value === selectedSortByValue,
    )?.label || SORT_BY_RELEVANCE_FILTER_OPTION.label;
  const capitalizedLabel = selectedSortByLabel
    .split(" ")
    .map((word) => capitalize(word))
    .join(" ");

  return (
    <ButtonWithPopOut
      id="search-sort-by-header-button"
      closeOnBlur
      __cssFor={buttonWithPopoutCss}
      horizontalOffset="0px"
      verticalOffset="6px"
      buttonContents={`Sort by ${capitalizedLabel}`}
      popOutContents={
        <div css={popoutContainerCss}>
          {SORT_BY_FILTER_OPTIONS.map((option) => {
            const isSelected = hasSearchParamValue(
              AgathaSchemaParamsEnum.sort_by,
              option.value,
            );

            return (
              <div key={option.value} css={buttonContainerCss}>
                {isSelected && <div css={selectedOptionIndicatorCss} />}

                <ButtonWithTrackEvent
                  dataProps={{
                    "data-qa-selector": `${option.value}-${AgathaSchemaParamsEnum.sort_by}-filter-option`,
                  }}
                  objectType={objectTypes.content}
                  actionName={actionNames.filter}
                  flavor={Button.flavors.incognito}
                  onClick={() =>
                    setSearchParamValue(
                      AgathaSchemaParamsEnum.sort_by,
                      option.value,
                    )
                  }
                  __cssFor={getSortByButtonOptionCss(isSelected)}
                >
                  {option.label}
                </ButtonWithTrackEvent>
              </div>
            );
          })}
        </div>
      }
    />
  );
};

ContentHeaderSortByButton.displayName = "Co40pxtentHeaderSortByButton";
export { ContentHeaderSortByButton };
